import Cookies from 'js-cookie';

const COOKIE_NAME = 'token';

const getCookieDomain = () => process.env.REACT_APP_COOKIE_DOMAIN || undefined;

/** Hapus sisa cookie token non-httpOnly lama di browser. */
export const clearAuthToken = () => {
    Cookies.remove(COOKIE_NAME, { path: '/' });
    const domain = getCookieDomain();
    if (domain) {
        Cookies.remove(COOKIE_NAME, { path: '/', domain });
    }
};

/**
 * @deprecated Token auth sekarang httpOnly dari backend.
 * Jangan set token di JS cookie lagi.
 */
export const setAuthToken = () => {
    clearAuthToken();
};
